import { render } from "./Team_index_bar_en.vue?vue&type=template&id=2250a9de&scoped=true"
import script from "./Team_index_bar_en.vue?vue&type=script&lang=js"
export * from "./Team_index_bar_en.vue?vue&type=script&lang=js"

import "./Team_index_bar_en.vue?vue&type=style&index=0&id=2250a9de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2250a9de"

export default script